module.exports = __webpack_public_path__ + "img/logo.69c98e8f.png";